import * as Yup from "yup";

const terceirizadoValidator = Yup.object().shape({
  descricao: Yup.string().required("Descrição do Serviço"),
  valorServico: Yup.number()
    .required("Valor do Serviço")
    .min(0.01, "Valor do Serviço deve ser maior ou igual a 0.01"),
});

const terceirizadoListValidator = Yup.array().of(terceirizadoValidator);

export { terceirizadoValidator, terceirizadoListValidator };
